import React from 'react';
import classNames from 'classnames';

import './style.scss';

const DossierMenu = ({ entities }) => {

  return (
    <div className="DossiersMenuContent">
      <div className="row">
        <div className="DossiersMenuContent__Items">
          {entities.map((entity, index) => {
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const classes = classNames('DossiersMenuContent__Items__Item col-12 col-md-12 col-lg-10');
            const url = entity.getIn(['metatag', 'value', 'canonical_url', 'attributes', 'href']);
            const name = entity.getIn(['name', 0, 'value']);

            return (
              <div key={uuid} className={classes}>
                <a href={url} className="icon-after icon-chevron-right">
                  {name}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DossierMenu;
